<template>
<div class="visual-process">
    <h3>{{ produktnaam }}verzekering</h3>
		<div class="grid-container">

			<step1schademelden-component
					:ctx="ctx"
					:schademeldenurl="schademeldenurl"
			></step1schademelden-component>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-archive clean"></p>
				</div>
				<h4>In behandeling</h4>
				<p>Wij nemen uw schademelding binnen 48 uur in behandeling.</p>
				<a href="#" data-toggle="modal" data-target="#behandelingmodal" >Lees meer</a>
			</div>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-user clean"></p>
				</div>
				<h4>Beoordeling</h4>
				<p>Uw schade wordt beoordeeld door een schade-expert, deze binnen 48 uur contact met u op.</p>
				<a href="#" data-toggle="modal" data-target="#beoordelingmodal" >Lees meer</a>
			</div>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-check clean"></p>
				</div>
				<h4>Afgehandeld</h4>
				<p>Wij hebben uw dossier gesloten.</p>
			</div>

		</div>


	<!-- Modal in behandeling -->
			<div class="modal fade" id="behandelingmodal" tabindex="-1" role="dialog" aria-hidden="true">
			  <div class="modal-dialog" role="document">
			    <div class="modal-content">
			      <div class="modal-header">
			        <h5 class="modal-title">In behandeling</h5>
			        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			          <span aria-hidden="true">x</span>
			        </button>
			      </div>
			      <div class="modal-body">
			        <p>Wij adviseren u, indien nog niet gekozen, gebruik te maken van onze herstelservice.</p>
					  <br />
                    <p>Kiest u voor onze herstelservice, dan schakelen wij CED Repair in. Zij maakt binnen 2 werkdagen telefonisch met u een afspraak. Voordelen van herstel via CED Repair is dat wij de schade rechtstreeks afrekenen met de hersteller en het standaard eigen risico vervalt. U ontvangt een bevestiging wanneer wij aan de hersteller betaald hebben.</p>
					  <br />
                    <p>Kiest u voor uw eigen hersteller of herstelt u de schade zelf dan schakelen wij, afhankelijk van het schadebedrag, een expert in of vragen de offerte/nota’s en eventuele aanvullende bewijsstukken bij u op.</p>
			        	
			      </div>
			      <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-modal-close">OK</button>	
			      </div>
			    </div>
			  </div>
			</div>
		<!-- end Modal -->

		<!-- Modal beoordeling -->
			<div class="modal fade" id="beoordelingmodal" tabindex="-1" role="dialog" aria-hidden="true">
			  <div class="modal-dialog" role="document">
			    <div class="modal-content">
			      <div class="modal-header">
			        <h5 class="modal-title">Beoordeling</h5>
			        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			          <span aria-hidden="true">x</span>
			        </button>
			      </div>
			      <div class="modal-body">
			        <p>Na ontvangst van het expertiserapport of de offerte/nota’s/overige bewijsstukken wikkelen wij de schade met u af.</p>
			        	
			      </div>
			      <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-modal-close">OK</button>	
			      </div>
			    </div>
			  </div>
			</div>
		<!-- end Modal -->





</div> 
</template>

<script>

    import step1SchadeMelden from './step1schademelden.vue'

export default {
  name: 'schadeproces-component',
    components: {
        'step1schademelden-component': step1SchadeMelden
    },
  props: {	  
	  ctx: String,
      produktnaam: String,
      schademeldenurl: String,
  },
  data: function () {
    return {    	
     }
  } 
  
}

</script>




// WEBPACK FOOTER //
// woonhuis.vue?70aa3a78